import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatLabel } from '@angular/material/input';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { AdminComponentBase, PageSimpleContentComponent } from 'app/layout/content';
import { ErrorComponent } from 'app/shared/components/error.component';
import { SaveButtonComponent } from 'app/shared/components/save-button.component';
import { Store, StoreCleanupConfig } from 'app/shared/graph';

import { CleanupConfigService } from './cleanup-config.service';

@Component({
    imports: [
        PageSimpleContentComponent,
        FormsModule,
        MatFormFieldModule,
        MatInput,
        MatLabel,
        RouterModule,
        ErrorComponent,
        SaveButtonComponent
    ],
    templateUrl: './store-cleanup-config-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './store-cleanup-config-page.component.scss'
})
export class StoreCleanupConfigPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly route = inject(ActivatedRoute);
    private readonly cleanupConfigService = inject(CleanupConfigService);

    storeId: string;
    storeWithCleanupConfig?: Store;
    cleanupConfig: StoreCleanupConfig = {};

    ngOnInit(): void {
        this.registerSubscription(this.route.params.subscribe(params => {
            this.storeId = params.storeId;
            this.subscribeWithGenericLoadingErrorHandling(this.cleanupConfigService.getStoreCleanupConfig(this.storeId), (store) => {
                this.storeWithCleanupConfig = store;
                this.cleanupConfig = { ...store.cleanupConfig };
            });
        }));
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    save() {
        this.subscribeWithGenericSavingErrorHandling(this.cleanupConfigService.updateStoreCleanupConfig({
            storeId: this.storeId,
            ...this.cleanupConfig
        }));
    }

}
